import { SectionType } from '@modules/section/enums/section-type.enum';

import { TestRouteCollectionModel } from './test-route-collection.model';
import { TestRouteInterface, TestRouteModel } from './test-route.model';

export interface TestRoutePageInterface {
  id: string;
  type: string;
  headline: string;
  anchor: string;
  latMin: string;
  lngMin: string;
  latMax: string;
  lngMax: string;
  latCenter: string;
  lngCenter: string;
  routes: TestRouteInterface[];
  consentBackgroundImgUrl: string;
}

export class TestRoutePageModel {
  public id: string;
  public type = SectionType.TEST_ROUTE;
  public headline: string;
  public anchor: string;
  public customHeadline = true;

  public latMin: number;
  public lngMin: number;
  public latMax: number;
  public lngMax: number;

  public routeCollections: TestRouteCollectionModel[] = [];

  public center: { lng: number; lat: number };

  public consentBackgroundImgUrl: string;

  private routes: TestRouteModel[] = [];

  constructor(data: TestRoutePageInterface) {
    this.id = data.id;
    this.headline = data.headline;
    this.anchor = data.anchor;

    this.latMin = Number(data.latMin);
    this.lngMin = Number(data.lngMin);
    this.latMax = Number(data.latMax);
    this.lngMax = Number(data.lngMax);

    this.center = {
      lat: Number(data.latCenter),
      lng: Number(data.lngCenter),
    };

    this.consentBackgroundImgUrl = data.consentBackgroundImgUrl;

    const routesByDay: { [key: number]: TestRouteCollectionModel } = {};
    data.routes
      .map((route) => new TestRouteModel(route))
      .sort((a, b) => a.day - b.day)
      .forEach((item) => {
        if (!routesByDay[item.day]) {
          routesByDay[item.day] = new TestRouteCollectionModel(item.day);
        }
        this.routes.push(item);
        routesByDay[item.day].addRoute(item);
      });
    this.routeCollections = Object.values(routesByDay);
  }
}
